import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule, routiningComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import {FormsModule} from '@angular/forms';
import { HeaderMainindexComponent } from './header-mainindex/header-mainindex.component';
import { HeaderMainsearchResultComponent } from './header-mainsearch-result/header-mainsearch-result.component';
import { MainbrowseTsicComponent } from './mainbrowse-tsic/mainbrowse-tsic.component';
import { MaincontractusComponent } from './maincontractus/maincontractus.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HttpClientModule } from "@angular/common/http";
import { Notfoundpage404Component } from './notfoundpage404/notfoundpage404.component';



@NgModule({
  declarations: [
    AppComponent,
    routiningComponents,
    HeaderMainindexComponent,
    HeaderMainsearchResultComponent,
    MainbrowseTsicComponent,
    Notfoundpage404Component
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
